// extracted by mini-css-extract-plugin
export default {"skills-section":"Skills_skills-section__qJrRA","container":"Skills_container__5+yxw","title":"Skills_title__DU1mm","skills":"Skills_skills__SAlV1"};